import React, { useEffect, useState, useRef } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import axiosInstance from "../../../lib/axios";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "AccGrpName", label: "Group Name", minWidth: 100 },
  { id: "AccGrpabvr", label: "Abbreviation", minWidth: 50 },
  { id: "AccmGrpId", label: "Under Group", minWidth: 100 },
];

const GroupMaster = () => {
  const [formData, setFormData] = useState({
    AccGrpName: "",
    AccGrpabvr: "",
    AccmGrpId: "",
    Remark: "",
  });

  const [error, setError] = useState({
    AccGrpName: false,
    AccGrpabvr: false,
    AccmGrpId: false,
    Remark: false,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [UserId] = useState(sessionStorage.getItem("UserId") || "1");
  const [currentAccGrpId, setCurrentAccGrpId] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [mode, setMode] = useState("view");
  const [Status, setStatus] = useState("1");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [dataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const nameRef = useRef(null);
  const abvrRef = useRef(null);
  const groupRef = useRef(null);

  useEffect(() => {
    console.log("formData updated:", formData);
  }, [formData]);

  // Group Dropdown fill 
  useEffect(() => {
    const fetchGroupDropdown = async () => {
      try {
        const response = await axiosInstance.post("AccmGrp/GetAccmGrpDrp", {});
        if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
          const formattedOptions = response.data.Data.map((item) => ({
            Id: item.AccmgrpId,
            Name: item.AccmgrpName,
          }));
          setGroupOptions(formattedOptions);
        } else {
          toast.info("No group dropdown data available");
        }
      } catch (error) {
        console.error("Error fetching group dropdown:", error);
        toast.error("Error fetching group dropdown data");
      }
    };

    fetchGroupDropdown();

    // Check if selectedRow is passed from GroupMstTable
    if (location.state && location.state.selectedRow) {
      const selectedRow = location.state.selectedRow;
      setCurrentAccGrpId(selectedRow.AccGrpId);
      setFormData({
        AccGrpName: selectedRow.AccGrpName || "",
        AccGrpabvr: selectedRow.AccGrpabvr || "",
        AccmGrpId: selectedRow.AccmGrpId?.toString() || "",
        Remark: selectedRow.Remark || "",
      });
      setStatus(selectedRow.Status === "Active" ? "1" : "0");
      setMode("view");
      setIsFormDisabled(true);
    } else if (location.state && location.state.AccGrpId) {
      // Fallback to fetching data if only AccGrpId is provided
      setCurrentAccGrpId(location.state.AccGrpId);
      fetchGroupData(location.state.AccGrpId, "L");
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post("AccGrp/GetAccGrpDashBoard", {
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error("No data found in response");
          setRows([]);
          setDataForPrint({});
        }
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
        toast.error("Error fetching dashboard data");
      }
    };
    getRow();
  }, []);

  // Fetching or Retrieving the api response
  const fetchGroupData = async (id, flag) => {
    try {
      const response = await axiosInstance.post("AccGrp/RetriveAccGrp", {
        AccGrpId: parseInt(id),
        Flag: flag,
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const groupData = Array.isArray(response.data.Data) ? response.data.Data[0] : response.data.Data;
        if (groupData) {
          setFormData({
            AccGrpName: groupData.AccGrpName || "",
            AccGrpabvr: groupData.AccGrpabvr || "",
            AccmGrpId: groupData.AccmGrpId?.toString() || "",
            Remark: groupData.Remark || "",
          });
          setStatus(groupData.Status?.toString() || "0");
          setIsFormDisabled(true);
          setCurrentAccGrpId(groupData.AccGrpId);
          setMode("view");
        } else {
          toast.info("No group data found in response");
          setFormData({
            AccGrpName: "",
            AccGrpabvr: "",
            AccmGrpId: "",
            Remark: "",
          });
          setStatus("0");
          setIsFormDisabled(true);
          setMode("view");
        }
      } else {
        toast.info(response.data.Message || "No group data found for the given ID");
        setFormData({
          AccGrpName: "",
          AccGrpabvr: "",
          AccmGrpId: "",
          Remark: "",
        });
        setStatus("0");
        setIsFormDisabled(true);
        setMode("view");
      }
    } catch (error) {
      console.error("Error fetching group data:", error);
      toast.error("Error fetching group data");
    }
  };

  const handleInputChange = (event, newValue) => {
    if (event && event.target) {
      const { name, value } = event.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
      setError((prev) => ({ ...prev, [name]: !value }));
    } else {
      const selectedId = newValue ? newValue.Id.toString() : "";
      setFormData((prev) => ({
        ...prev,
        AccmGrpId: selectedId,
      }));
      setError((prev) => ({ ...prev, AccmGrpId: !selectedId }));
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === nameRef.current) {
        abvrRef.current.focus();
      } else if (event.target === abvrRef.current) {
        groupRef.current.focus();
      } else {
        handleSave();
      }
    }
  };

  // Status Change 
  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  // submit the  Form
  const handleSave = async () => {
    let hasError = false;

    if (!formData.AccGrpName) {
      setError((prev) => ({ ...prev, AccGrpName: true }));
      toast.error("Group Name is required");
      hasError = true;
    }

    if (!formData.AccmGrpId) {
      setError((prev) => ({ ...prev, AccmGrpId: true }));
      toast.error("Under Group is required");
      hasError = true;
    }

    if (hasError) return;

    try {
      const payload = {
        AccGrpName: formData.AccGrpName,
        AccGrpabvr: formData.AccGrpabvr,
        AccmGrpId: parseInt(formData.AccmGrpId),
        Status: Status,
        Remark: formData.Remark,
        seqNo: "001",
        lockSt: "N",
        lockId: null,
        CreatedBy: parseInt(UserId),
      };

      let response;
      if (mode === "edit") {
        payload.AccGrpId = currentAccGrpId;
        payload.UpdatedBy = parseInt(UserId);
        response = await axiosInstance.post("AccGrp/UpdateAccGrp", payload);
      } else {
        response = await axiosInstance.post("AccGrp/InsertAccGrp", payload);
      }

      console.log("Save Response:", response.data);

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message || "Group saved successfully");
        const newId =
          response.data.Data?.AccGrpId || response.data.Data || currentAccGrpId;
        if (newId) {
          await fetchGroupData(newId, "L");
          setCurrentAccGrpId(newId);
          setMode("view");
          setIsFormDisabled(true);
        } else {
          toast.error("No ID returned from save operation");
        }
      } else {
        toast.error(response.data.Message || "Failed to save group");
      }
    } catch (error) {
      console.error("Error saving/updating group:", error);
      toast.error("Error saving/updating group");
    }
  };

  // Edit 
  const handleEdit = async () => {
    if (!currentAccGrpId) {
      toast.error("No record selected to edit");
      return;
    }
    let flag = await checkAndLock(currentAccGrpId, "AccGrp", "AccGrpId");
    switch (flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        setTimeout(() => nameRef.current.focus(), 0);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Lock", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  // Add button 
  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(true);
    // fetchGroupData(currentAccGrpId, "R");
    setFormData({
      AccGrpName: "",
      AccGrpabvr: "",
      AccmGrpId: "",
      Remark: "",
    });
    setStatus("1");
    setCurrentAccGrpId(null);
    setError({ AccGrpName: false, AccGrpabvr: false, AccmGrpId: false, Remark: false });
    setTimeout(() => nameRef.current.focus(), 0);
  };

  const handlePrevious = async () => {
    if (currentAccGrpId && currentAccGrpId > 1) {
      await fetchGroupData(currentAccGrpId, "P");
    }
  };

  const handleNext = async () => {
    if (currentAccGrpId) {
      await fetchGroupData(currentAccGrpId, "N");
    }
  };

  const handleCancel = async () => {
    try {
      await UnLock(currentAccGrpId, "AccGrp", "AccGrpId");
      await fetchGroupData(currentAccGrpId, "L");
      setStatus("1");
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      console.error("Error during cancel:", error);
      toast.error("Error occurred while cancelling");
    }
  };

  const handleExit = () => {
    navigate("/groupmsttable");
  };

  const handleDeleteClick = () => {
    if (currentAccGrpId) {
      setOpenConfirmDialog(true);
    } else {
      toast.error("No record selected to delete");
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  // Handle delete action
  const handleConfirmDelete = async () => {
    let flag = await checkAndLock(currentAccGrpId, "AccGrp", "AccGrpId");
    switch (flag) {
      case 0:
        await fetchGroupData(currentAccGrpId, "D");
        await fetchGroupData(currentAccGrpId, "N");
        setOpenConfirmDialog(false);
        setMode("view");
        setIsFormDisabled(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Lock", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{ backgroundColor: "#635BFF", marginRight: { xs: "5px", sm: "10px" }, display: { xs: "none", sm: "block" } }}
                disabled={mode !== "view" || !currentAccGrpId || currentAccGrpId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                onClick={handleNext}
                sx={{ backgroundColor: "#635BFF", display: { xs: "none", sm: "block" } }}
                disabled={mode !== "view" || !currentAccGrpId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              GL Group Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Groups"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Grid container spacing={2}>
              {/* <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="AccGrpName"
                  name="AccGrpName"
                  label={
                    <span>
                      Group Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  disabled={isFormDisabled || mode === "edit" || mode === "view"}
                  value={formData.AccGrpName}
                  onChange={handleInputChange}
                  error={error.AccGrpName}
                  helperText={error.AccGrpName && "Group Name is required"}
                  inputRef={nameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid> */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="AccGrpName"
                  name="AccGrpName"
                  label={
                    <span>
                      Group Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled || mode === "edit" || mode === "view"}
                  value={formData.AccGrpName}
                  onChange={handleInputChange}
                  error={error.AccGrpName}
                  helperText={error.AccGrpName && "Group Name is required"}
                  inputRef={nameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="AccGrpabvr"
                  name="AccGrpabvr"
                  label={
                    <span>
                      Abbreviation
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled || mode === "edit" || mode === "view"}
                  value={formData.AccGrpabvr}
                  onChange={handleInputChange}
                  error={error.AccGrpabvr}
                  helperText={error.AccGrpabvr && "Abbreviation is required"}
                  inputRef={abvrRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <CustomAutocomplete
                  options={groupOptions}
                  id="AccmGrpId-autocomplete"
                  name="AccmGrpId"
                  label={
                    <span>
                      Under Group <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  getOptionLabel={(option) => option.Name || ""}
                  value={
                    groupOptions.find((option) => option.Id === parseInt(formData.AccmGrpId)) || null
                  }
                  onChange={handleInputChange}
                  disabled={isFormDisabled || mode === "edit" || mode === "view"}
                  error={error.AccmGrpId}
                  helperText={error.AccmGrpId ? "Under Group is required" : ""}
                  ref={groupRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #d4d4d4, #ffffff)" }}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1, background: "linear-gradient(290deg, #a7c5e9, #ffffff)" }}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: "none" }}>
        {Object.keys(dataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="GL Group Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>

      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GroupMaster;